<div class="modal__header">
    <h2 class="title" id="modal__title">{{title$|async}}</h2>
    <div class="modal__header-actions">
        <button aria-label="Close dialog" (click)="cancel()">
			<app-svg svg="icons.svg#general--close" [alt]="'Close icon'"></app-svg>
		</button>
    </div>
</div>
<div class="modal__body sl--scrollable" #modalBodyDiv>
</div>
<div class="modal__footer">
    <div *ngIf="cancelLabel$ | async" class="modal__footer-action negative-action">
        <button class="button button--small" (click)="cancel()">
			{{cancelLabel$|async}}
		</button>
    </div>
    <div class="modal__footer-action positive-action" *ngIf="(isAccent$|async)">
        <button class="button button--small button-accent" (click)="confirm()">
			{{okLabel$|async}}
		</button>
    </div>
    <div class="modal__footer-action positive-action" *ngIf="!(isAccent$|async)">
        <button class="button" (click)="confirm()">
			{{okLabel$|async}}
		</button>
    </div>
</div>